import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { CmpsDatePipe } from '../common/date.pipe';
import { PeriodType } from '../widget/date-range.widget.model';

import { QuickSwitch, QuickSwitchItem } from './config.insight.model';
import { TranslationKeyMap } from './insight.i18n';
import { CacheDateItem } from './performance-data/cache-date.pd.model';
import { getEventDateValue, PeriodTypeOpts } from './period.insight.model';

@Component({
    selector: '[cmpsInsightSelectionSummary]',
    templateUrl: './selection-summary.insight.component.html',
})
export class SelectionSummaryInsightComponent implements OnChanges {
    @Input() periodType: PeriodType;
    @Input() cacheDates: CacheDateItem[];
    @Input() eventDate: Date;
    @Input() quickSwitch: QuickSwitch;
    @Input() quickSwitchItem: QuickSwitchItem;
    @Input() quickSwitchLabel: string;

    /** @privte */
    _i18n = TranslationKeyMap;

    /** @privte */
    _finalPeriodTypeOpt: string;

    /** @privte */
    _finalDateRangeValue: string;

    /** @privte */
    _finalQuickSwitch: string;

    constructor(private readonly _datePipe: CmpsDatePipe) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (
            changes.periodType != null ||
            changes.cacheDates != null ||
            changes.eventDate != null ||
            changes.quickSwitch != null ||
            changes.quickSwitchItem != null ||
            changes.quickSwitchLabel != null
        ) {
            this._setValues();
        }
    }

    private _setValues(): void {
        this._finalPeriodTypeOpt = PeriodTypeOpts.find(
            (e) => e.value === this.periodType,
        )?.tlKey;

        this._finalDateRangeValue = getEventDateValue(
            this.cacheDates,
            this.eventDate,
            this.periodType,
            this._datePipe,
        );

        this._finalQuickSwitch =
            this.quickSwitch?.title ?? this.quickSwitchLabel ?? '';
    }
}
